import styled from 'styled-components';
import { MMediaBorderStrokeWidth } from './MMediaBorder.types';
interface WrapperProps {
  $aspectRatio: string;
  $strokeWidth: MMediaBorderStrokeWidth;
}

/**
 * This function returns the width of the border based on the stroke width.
 * @param strokeWidth - The stroke width to get the width of the border.
 * @returns The width of the border.
 */
const getBorderWidth = (strokeWidth: MMediaBorderStrokeWidth): string => {
  switch (strokeWidth) {
    case MMediaBorderStrokeWidth.Small:
      return 'var(--general-spacer-02, 8px)';
    case MMediaBorderStrokeWidth.Medium:
      return 'var(--general-spacer-03, 16px)';
    case MMediaBorderStrokeWidth.Large:
      return 'var(--general-spacer-04, 24px)';
    case MMediaBorderStrokeWidth.None:
    default:
      return '0px';
  }
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  width: 100%;
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio.replace(':', '/')};
  border: ${({ $strokeWidth }) => getBorderWidth($strokeWidth)} solid var(--t-brand-bg-color);
  overflow: hidden;

  > * {
    width: 100%;
    height: 100%;
  }

  [data-component-name='m-web-ui-kit-MMediaSelector'] {
    border-radius: 0;

    [data-component-name='a-web-ui-kit-AImage'] {
      height: 100%;
    }

    [data-component-name='m-web-ui-kit-MVideoBackground'],
    [data-component-name='m-web-ui-kit-MVideoThumbnail'] {
      border-radius: 0;
    }
  }
`;
